import VideoClosedCaptionsFilledIcon from '@atlaskit/icon-lab/core/video-closed-captions-filled';
import * as React from 'react';

export function SvgCCOn() {
  return <VideoClosedCaptionsFilledIcon label="" testId="ads-refreshed-icon" />;
}
